import { lazy, Suspense, useEffect } from 'react'
import { useFeedback } from './FeedbackContext'
import { useFeedbackTrigger } from './useFeedbackTrigger'

const FeedbackToast = lazy(() =>
  import('./FeedbackToast').then((m) => ({ default: m.FeedbackToast })),
)

/**
 * Mount once in AppShellMainChrome. Runs the auto-trigger listener and
 * lazy-loads the toast component only when feedback is actually open —
 * keeps the main bundle untouched.
 */
export function FeedbackHost() {
  const { isOpen, open } = useFeedback()

  useFeedbackTrigger()

  useEffect(() => {
    ;(window as any).openFeedback = () => open({ triggerType: 'manual' })
    return () => { delete (window as any).openFeedback }
  }, [open])

  if (!isOpen) return null

  return (
    <Suspense fallback={null}>
      <FeedbackToast />
    </Suspense>
  )
}
